import React from 'react';
import { TextField } from '@mui/material';
import { FaExclamationCircle } from 'react-icons/fa';

const DescripcionFalla = ({ form, onChange }) => {
  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaExclamationCircle /> SERVICIO REQUERIDO</div>
      <div className="card-body">
        <TextField
          label="Servicio Requerido *"
          name="descripcion"
          value={form.descripcion}
          onChange={onChange}
          required
          multiline
          rows={4}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Observaciones"
          name="observaciones"
          value={form.observaciones}
          onChange={onChange}
          multiline
          rows={3}
          fullWidth
        />
      </div>
    </div>
  );
};

export default DescripcionFalla;
